export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
              联系我们
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-extrabold text-foreground-900 mb-4">
              有建议或想法？欢迎告诉我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              棒棒TV始终重视每一位观众的使用体验。如果你对平台有任何建议、
              内容需求或合作意向，欢迎通过以下方式与我们取得联系。你的每一条反馈都是我们进步的动力。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a href="mailto:hello@bbtv.example.com" className="whitespace-nowrap flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
                发送邮件
              </a>
              <div className="whitespace-nowrap flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-50 border border-background-200/70 text-foreground-600 text-sm font-medium">
                <i className="ri-wechat-line"></i>
                微信公众号：棒棒TV
              </div>
              <div className="whitespace-nowrap flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-50 border border-background-200/70 text-foreground-600 text-sm font-medium">
                <i className="ri-weibo-line"></i>
                微博：@棒棒TV官方
              </div>
            </div>
          </div>
          <div className="flex-1 w-full max-w-md">
            <div className="relative aspect-square w-full max-w-[280px] mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20abstract%20illustration%20of%20customer%20support%20and%20communication%2C%20warm%20coral%20and%20amber%20shapes%2C%20friendly%20and%20approachable%20style%2C%20modern%20flat%20design%20with%20soft%20gradients&width=600&height=600&seq=bbtv-contact-visual&orientation=squarish"
                alt="棒棒TV联系我们"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}